import React, { createContext, useState, useEffect } from 'react'
import data from '../data/questions.json'
import answerStrings from '../data/answerString'
import answerValues from '../data/answers'
import answers from '../data/answers.json'
import countryList from '../data/countryList.json'
import _ from 'lodash'
import getTreeData, { regionOrder } from '../data/treeData.js';
import usePrevious from '../hooks/usePrevious.js';

export const ChartContext = createContext()

const mainData = data.questions
const uniqIds = _.uniq([..._.uniq(answers.hrds.map(el => +el.cid)), ..._.uniq(answers.les.map(el => +el.cid))])


const storeValues = (storageKey, values) => {
    localStorage.setItem(
        storageKey,
        JSON.stringify(values)
    )
}

const readStoredValues = (storageKey, mapFilterInit, metricQuestionsInit) => {

    const valuesMap = JSON.parse(localStorage.getItem(storageKey))

    return valuesMap 
                ? valuesMap 
                : { displayedMetrics: metricQuestionsInit,
                    mapFilterValues: mapFilterInit,
                    filterQuestions: [],
                    chartQuestions: [],
                    filteredAnswers: [] }
}
    
const ChartContextProvider =(props) => {

    const [ borderDroppable,  setBorderDroppable ] = useState(false)
    const [ windowWidth, setWindowWidth ] = useState(0)
    const [ path, setPath ] = useState('both')
    const [ metricQuestions,  setMetricQuestions ] = useState(data.questions)

    const { regionList } = getTreeData(path)
    
    const prevPath = usePrevious(path)
    const storedValues = readStoredValues(path, regionList, metricQuestions)

    const [ displayedMetrics, setDisplayedMetrics ] = useState([])
    const [ filterQuestions, setFiltersQuestions ] = useState([])
    const [ chartQuestions, setChartQuestions ] = useState([])
    const [ mapFilterValues, setMapFilterValues ] = useState([])
    const [ filteredAnswers, setFilteredAnswers ] = useState([])

    const [ futureFilteredAnswer, setFutureFiltereAnswer ] = useState([])
    const [ futureMapFilterValues, setFutureMapFilterValues ]  = useState([])

    const [ hideFilters, setHideFilters ] = useState(false)   
    const [ filtersAppliedToggle, setFiltersAppliedToggle ] = useState(false)
    const [ position, setPosition ] = useState('left') 
    
    const [ showHidden, setShowHidden ] = useState(false)
    const [ reset , setReset ] = useState(false)
    
    useEffect(() => {
        prevPath === path &&
        storeValues(path, { filterQuestions, chartQuestions, displayedMetrics , mapFilterValues, filteredAnswers})
    }, [filterQuestions, chartQuestions, displayedMetrics , mapFilterValues, filteredAnswers, path])

    useEffect(() =>  {
        setFiltersQuestions(storedValues.filterQuestions)
        setDisplayedMetrics(storedValues.displayedMetrics)
        setChartQuestions(storedValues.chartQuestions)
        setMapFilterValues(storedValues.mapFilterValues)
        setFutureMapFilterValues(storedValues.mapFilterValues)
        setFilteredAnswers(storedValues.filteredAnswers)
    }, [path])

    useEffect(() => {
        setShowHidden(false)
        let timer = setTimeout(() => setShowHidden(true), 1000)
    }, [path])

    const getFilterStrings = set => {
        const filterSrings = set.map(el =>{
                const changedEl = el.answer === 'Female' ? { ...el, answer: 'woman' } : { ...el }
                const answers = answerValues[changedEl.qid].answers
                const answerIndex = answers.findIndex(d => d === el.answer)
                return { qid: changedEl.qid, answerString: answerStrings[changedEl.qid].strings[answerIndex].toLowerCase() }
         })

         return filterSrings
    }

    const filterStrings = getFilterStrings(filteredAnswers)
    const futureFilteredStrings = getFilterStrings(futureFilteredAnswer)
  
    let filteredHrdsData = answers.hrds // For charts and total filter calculations
    let filteredLesData = answers.les // For charts and total filter calculations
    let dataSet = path === "hrds" ? filteredHrdsData : filteredLesData
    let futureDataSet = path === "hrds" ? filteredHrdsData : filteredLesData
    const addOrDeduct = filterStrings.map(el => el ? el.answerString : el ).includes(futureFilteredStrings[0] ? futureFilteredStrings[0].answerString : null)

    
    const filteredRegions = mapFilterValues.filter(el => regionOrder.includes(el))
    const filteredCountries = mapFilterValues.filter(el => !regionOrder.includes(el))
    let filteredDataset =  dataSet.filter(el => filteredCountries.includes(el.country) || filteredRegions.includes(el.region))
    const futureFilteredCountries = futureMapFilterValues.filter(el => !regionOrder.includes(el))
    let filteredPotentialDataset =  dataSet
    const futureStrings = addOrDeduct 
        ? filterStrings.filter(el => el.answerString !== futureFilteredStrings[0].answerString)
        : [ ...filterStrings, ...futureFilteredStrings ]
    let filteredFutureDataSet = futureDataSet.filter(el => futureFilteredCountries.includes(el.country) || filteredRegions.includes(el.region))
    filterStrings.forEach(el => filteredDataset = filteredDataset.filter(d => d[el.qid] && !d[el.qid].toLowerCase().includes(el.answerString.toLowerCase())) )
    filterStrings.forEach(el => filteredPotentialDataset = filteredPotentialDataset.filter(d => d[el.qid] && !d[el.qid].toLowerCase().includes(el.answerString.toLowerCase())) )
    futureStrings.forEach(el => filteredFutureDataSet = filteredFutureDataSet.filter(d => d[el.qid] && !d[el.qid].toLowerCase().includes(el.answerString.toLowerCase())) )
    
    const countryTotals = uniqIds.map(d => {
        const countryTotalHrds = filteredHrdsData.filter(el => +el.cid === +d).length
        const countryTotalLes =  filteredLesData.filter(el => +el.cid === +d).length
        const dataSetTotals = filteredDataset.filter(el => +el.cid === +d).length
        const countryName = countryList.countryList.find(el => +el.cid === +d)
        return { cid: +d, countryName: countryName.country, total:  path === "both" ? countryTotalHrds + countryTotalLes : dataSetTotals}
    })

    const expectedCountryTotals = uniqIds.map(d => {
        const dataSetTotals = filteredFutureDataSet.filter(el => +el.cid === +d).length
        const countryName = countryList.countryList.find(el => +el.cid === +d)
        return { cid: +d, countryName: countryName.country, total:  dataSetTotals}
    })

    const potentialCountryTotals = uniqIds.map(d => {
        const dataSetTotals = filteredPotentialDataset.filter(el => +el.cid === +d).length
        const countryName = countryList.countryList.find(el => +el.cid === +d)
       return { cid: +d, countryName: countryName.country, total: dataSetTotals}
    })

    const handleResize = () => {
        setWindowWidth({windowWidth: window.innerWidth});
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize)
    }, [])

    return ( 
        <ChartContext.Provider value={{ 
            borderDroppable,  setBorderDroppable,
            metricQuestions,  setMetricQuestions,
            displayedMetrics, setDisplayedMetrics,
            filterQuestions, setFiltersQuestions,
            chartQuestions, setChartQuestions, mainData,
            filteredAnswers, setFilteredAnswers,
            filtersAppliedToggle, setFiltersAppliedToggle,
            hideFilters, setHideFilters, countryTotals,
            position, setPosition, path, setPath,
            windowWidth, reset , setReset ,
            filteredHrdsData, filteredLesData, dataSet,
            futureFilteredAnswer, setFutureFiltereAnswer, potentialCountryTotals, expectedCountryTotals,
            mapFilterValues, setMapFilterValues, filteredDataset,
            showHidden,
            futureMapFilterValues, setFutureMapFilterValues 
         }}>
            {props.children}
        </ChartContext.Provider>
    );
}
 
export default ChartContextProvider;